import React from 'react';
import { AppHeader , HeaderIcons } from '../shared';
import BurgerMenu from './BurgerMenu';
import { appVariant } from '../../config';
import { getMenuGameLinks } from '../../config/gameLinks';
import { useTranslation } from '../../i18n';
import { getGameLinkName } from '../../i18n/helpers';

interface MenuPageWrapperProps {
  title: string;
  children: React.ReactNode;
  onMenuClick: (page: 'how-to-play' | 'premium' | 'support') => void;
  onBack?: () => void;
  gameType?: 'blitz' | 'team' | 'family' | 'party';
}

const MenuPageWrapper: React.FC<MenuPageWrapperProps> = ({
  title,
  children,
  onMenuClick,
  onBack,
  gameType
}) => {
  const { t } = useTranslation();

  const getGameType = (): 'blitz' | 'team' | 'family' | 'party' => {
    if (gameType) return gameType;
    const variantMap: Record<string, 'blitz' | 'team' | 'family' | 'party'> = {
      blitz: 'blitz',
      team: 'team',
      family: 'family',
      party: 'party',
      new: 'party',
      coop: 'blitz',
    };
    return variantMap[appVariant] || 'blitz';
  };

  const gameLinks = getMenuGameLinks(getGameType());

  const menuItems = [
    {
      id: 'play-another-game-header',
      label: t('lobby.menu.playAnotherGamePack'),
      isSectionHeader: true,
    },
    ...gameLinks.map(link => ({
      id: link.id,
      label: getGameLinkName(link.id),
      href: link.url,
    })),
    {
      id: 'menu-divider',
      isDivider: true,
    },
    {
      id: 'menu-section-header',
      label: t('lobby.menu.sectionHeader'),
      isSectionHeader: true,
    },
    {
      id: 'how-to-play',
      label: t('common.howToPlay'),
      onClick: () => onMenuClick('how-to-play'),
    },
    {
      id: 'premium',
      label: t('common.premium'),
      onClick: () => onMenuClick('premium'),
    },
    {
      id: 'support',
      label: t('common.support'),
      onClick: () => onMenuClick('support'),
    },
  ];

  return (
    <div className="app" style={{ position: 'relative' }}>
      <AppHeader
        logo={null}
        leftButton={onBack ? {
          icon: HeaderIcons.back,
          onClick: onBack,
          tooltip: t('common.back'),
        } : undefined}
        rightButton={undefined}
        rightContent={<BurgerMenu items={menuItems} />}
      />
      <div className="container" style={{ marginTop: '80px', padding: '2rem' }}>
        {children}
      </div>
    </div>
  );
};

export default MenuPageWrapper;
